import { render } from "./frequencyLimitCY.vue?vue&type=template&id=56951032&scoped=true"
import script from "./frequencyLimitCY.vue?vue&type=script&lang=js"
export * from "./frequencyLimitCY.vue?vue&type=script&lang=js"

import "./frequencyLimitCY.vue?vue&type=style&index=0&id=56951032&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56951032"

export default script